import React from "react";

import { Stack } from "@mui/material";

import { ReactComponent as Correct } from "../../../Assets/Images/Icon/CorrectICON.svg";
import { Theme } from "../../../Style/Theme";
import { LoadingButtonType } from "../../atoms/LoadingButton/LoadingButton";
import { Heading } from "../../atoms/Typography/Heading/Heading";
import { FormItemsWrap } from "../Wrap/Wrap";

export const MessageForm = ({
  onClick,
  buttonInputMessage,
  footerClickEvent,
  messageLineOne,
  messageLineTwo,
  LoadingState,
}) => {
  const onSubmit = async (formData) => {
    try {
      formData.preventDefault();
      onClick(formData);
    } catch (error) {}
  };
  return (
    <div>
      <form onSubmit={onSubmit}>
        <FormItemsWrap gap={"18px"} alignItems={"center"}>
          <Stack
            style={{
              width: "136px",
              height: "136px",
              background: Theme.palette.background.primaryGreen,
              borderRadius: "50%",
            }}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Correct role="img" type="img" aria-label="Correct Icon" />
          </Stack>
          <Stack
            style={{
              display: "flex",
              flex: 1,
              textAlign: "center",
            }}
            direction={"column"}
            alignItems={"center"}
          >
            <Heading text={messageLineOne} />
            {messageLineTwo && <Heading text={messageLineTwo} />}
          </Stack>
          {onClick && (            
            <LoadingButtonType
              loading={LoadingState.visible}
              type="submit"
              variant={"primaryBlue"}
              fullWidth
            >
              {buttonInputMessage}
            </LoadingButtonType>
          )}
        </FormItemsWrap>
      </form>
    </div>
  );
};
